// print
$('body').on(
  'click',
  'a.printer, input[type=button].printer, button.printer',
  function () {
    ht.printPage();
    return false;
  }
);
